<template>



    <div class="search-result">
      <div class="search-result-header">
        <h4 class="search-result-title"> <a class="" :href="prog.url">{{prog.name}}</a> </h4>
        <h5 class="search-result-subtitle"> {{prog.code}} </h5>
      </div>
      <div class="search-result-body">
        <p class="" v-if="prog.description && prog.description.length > 3  ">{{prog.description}}</p>
      </div>

      <div class="search-result-footer">
        
      <div class="search-result-footer-item">
        <h5 class="meta-label">
          <i aria-hidden="true" class="icon-globe"></i> <span class="meta-labelText">Faculty</span></h5>
        <p class="">{{prog.relatedFaculty}} </p>
      </div>

      <!-- <div class="search-result-footer-item">
        <h5 class="meta-label">
          <i aria-hidden="true" class="icon-graduation-cap"></i> <span class="meta-labelText">Subject area</span></h5>
        <a href="#"><p class="">{{prog.parent}} </p></a>
      </div> -->

      <!-- <div class="search-result-footer-item" v-if="prog.trimester">
        <h5 class="meta-label"><i aria-hidden="true" class="icon-graduation-cap">
          </i> <span class="meta-labelText">Trimesters offered</span></h5>
        <p class="">{{prog.trimester}}</p>
      </div> -->

      </div>
    </div>

</template>

<script>
import Vue2Filters from 'vue2-filters';
import moment from 'moment';

  export default {
    name: 'ugprogramme',
    props: ['prog'],
    computed: {
      startDate () {
        
        if (this.prog.keyDateSet) {
          let dates = this.prog.keyDateSet.map(dateSet => {
            return dateSet.startDate
          });
  
          //removes null objects
          let startDates = dates.filter(Boolean).map( d => {
            return moment(d.date).format('YYYYMMDD')
          }).sort((a,b) => a - b)
  
          //get next date
          const today = moment().format('YYYYMMDD');
          const nextDate = startDates.find(d => d > today )
          
          return moment(nextDate).format('DD MMM YYYY');
        } else {
          return 'No dates found';
        }
      }
    },


  }

</script>

<style lang="scss" scoped>
  .c-stack-body {
    .meta--labelled {
      margin-bottom: 0;
    }
  }

    .search-result-footer-item {
      flex: 1 0 40% !important;
    }
</style>